import Ministry from '../../assets/ministry.png';
import QuizTeskTask from '../../assets/quiz-tesk-task.png';
import WheatherApp from '../../assets/wheather-app.png';
import Travel from '../../assets/Travel.png';
import nike from '../../assets/nike.png';

const data = [
  {
    id: 1,
    image: QuizTeskTask,
    url: 'https://kravazf.github.io/quiz-test-task-2/',
    title: 'Mobile Quiz Test',
    technologyStack: [
      'JS',
      'React.js',
      'Styled-component',
      'HTML5',
      'CSS3',
    ],
  },
  {
    id: 2,
    image: Ministry,
    url: 'https://kravazf.github.io/Ministry-Of-Smart-Play/',
    title: 'Ministry Of Smart Play',
    technologyStack: [
      'JS',
      'React.js',
      'HTML5',
      'CSS3',
      'Styled-component',
      'Redux-toolkit',
      'Material-UI',
      'Axios',
      'Rest full Api',
    ],
  },
  {
    id: 4,
    image: Travel,
    url: 'https://Kravazf.github.io/travel-app/',
    title: 'Travel app',
    technologyStack: [
      'JS',
      'React.js',
      'HTML5',
      'SCSS',
      'React-icons',
      'AOS - Animate on scroll library',
    ],
  },
  {
    id: 5,
    image: WheatherApp,
    url: 'https://kravazf.github.io/wheather-app/',
    title: 'Wheather App',
    technologyStack: [
      'JS',
      'React.js',
      'HTML5',
      'CSS3',
      'Styled-component',
    ],
  },
  {
    id: 6,
    image: nike,
    url: 'https://kravazf.github.io/vite-nike-landing-deploy/',
    title: 'Nike Clone App',
    technologyStack: [
      'JS',
      'React.js',
      'HTML5',
      'Tailwind CSS',
      'clsx',
      'Vite.js',
    ],
  },
];

export default data;
